/* eslint no-underscore-dangle: 0 */
import React from 'react';
// import { connect } from 'react-redux';
import { Button } from 'react-toolbox/lib/button';
import Title from '~/components/Title';

import style from './style.scss';

class ToolsPage extends React.Component {
  static contextTypes = {
    router: React.PropTypes.object.isRequired,
    dialogPush: React.PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {};
  }

  navigate(url) {
    this.context.router.history.push(url);
  }

  render() {
    return (
      <div style={{ padding: '10px' }} className={style.buttonArea}>
        <Title>Tools</Title>
        <div style={{ margin: '10px 0' }}>Here you will find some helpful tools to speed up work in Sherpa.</div>
        <Button label="Import order from 3D cart" primary raised icon="archive" onClick={() => this.navigate('/tools/3dcart-import')} />
        <Button label="Register incoming delivery" primary raised icon="local_shipping" onClick={() => this.navigate('/tools/incoming-delivery')} />
      </div>
    );
  }
}

export default ToolsPage;



// WEBPACK FOOTER //
// ./app/pages/Tools/index.js